import IJitRepository from '../domain/IJitRepository';
import { StockStatusMapper } from '../infrastructure/mappers/sstockStatus.mapper';
import jitRepository from '../infrastructure/repositories/JitRepository';

class GetStockStatusService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._jitRepository.getStockStatus({ queryParams }).then((res) => {
      return StockStatusMapper.fromDTO(res);
    });
  }
}

export default new GetStockStatusService({ repository: jitRepository });

export { GetStockStatusService };
